'use strict';

/**
 * Keeps track of whether component's DOM node is visible in viewport.
 *
 * You can optionally define a method called `getViewportLookaheadHeight`
 * to specify how many pixels above or below the viewport will nevertheless
 * be counted as "inside the viewport".
 */
var ViewportTestMixin = {
  getInitialState: function () {
    return {
      isInViewport: false
    };
  },

  componentDidMount: function () {
    this._updateViewportState();
    window.addEventListener('scroll', this._updateViewportState, false);
    window.addEventListener('resize', this._updateViewportState, false);
  },

  componentWillUnmount: function () {
    window.removeEventListener('scroll', this._updateViewportState, false);
    window.removeEventListener('resize', this._updateViewportState, false);
  },

  _updateViewportState: function () {
    if (this.isMounted()) {
      this.setState(this._getViewportState());
    }
  },

  _getViewportState: function () {
    return {
      isInViewport: this._isInViewport()
    };
  },

  _isInViewport: function () {
    var el = this.getDOMNode(),
        rect = el.getBoundingClientRect();

    return (
      rect.height > 0 &&
      rect.bottom >= 0 &&
      rect.top <= window.innerHeight &&
      rect.right >= 0 &&
      rect.left <= window.innerWidth
    );
  }
};

module.exports = ViewportTestMixin;


/** WEBPACK FOOTER **
 ** ./mixins/ViewportTestMixin.js
 **/